<template>
    <form>

      <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if='errorMessage'>
        {{ errorMessage }}
      </div>

      <div class="row">
        <div class="col-sm-8">
          <div class="card">
            <div class="card-body">
              <h4 class="header-title mt-0 mb-1">{{ $t('user.form.user_information') }}</h4>
              <p class="sub-header"></p>

              <div class="row mb-5">
                <div class="avatar-upload">
                  <div class="avatar-edit">
                    <input 
                      type='file' 
                      id="imageUpload" 
                      @change="onAvatarChange"
                      accept=".png, .jpg, .jpeg" />
                    <label for="imageUpload"><i class="uil uil-pen"></i>  </label>
                  </div>
                  <div class="avatar-preview">
                    <img
                      ref="imagePreview"
                      :src="model.avatar_path ? model.avatar_path : 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973461_960_720.png'"
                      alt
                      class="avatar-lg rounded-lg"
                    />
                  </div>
                </div>

                <div class="col-8">
                  <div class="mb-1 px-1">
                    <div class="bg-white industry_container" >
                      <div class="inputRoot">
                        <div class="rootLabel" style="width:90px">{{$t('user.form.email.label')}}</div>
                            <div class="pb-2 ml-3">
                              <span>{{ model.email }}</span>
                            </div>
                      </div>
                    </div>
                  </div>
                  <TextField 
                    class="col-md-12 px-4 mb-4"
                    :placeholder="$t('user.form.contact_no.placeholder')"
                    :label="$t('user.form.contact_no.label')"
                    v-model="model.contact_no"
                    :error="$v.model.contact_no.$error"
                    :errorMessage="$v.model.contact_no.errorMessage"
                  />
                  <Select
                    autoload
                    track-by="_id"
                    textField="name"
                    moduleName="role"
                    endpoint="get"
                    valueField=""
                    class="col-md-12 px-4 mb-1"
                    :placeholder="$t('user.form.access_type.placeholder')"
                    :label="$t('user.form.access_type.label')"
                    v-model="model.access_type"
                    :error="$v.model.access_type.$error"
                    :errorMessage="$v.model.access_type.errorMessage"
                    :options="access_type_options"
                    :parameters="{
                      type: parameters.type == 'users' ? 1 : parameters.type == 'company' ? 2 : parameters.type == 'individual' ? 3 : 3
                    }"
                  />
                </div>

                <div class="col-6" v-if="model.access_type == 'recruitment'">
                  <DropDown 
                    :placeholder="$t('user.form.recruitment_type.placeholder')"
                    :label="$t('user.form.recruitment_type.label')"
                    v-if="user.role.role != 'recruitment'"
                    :name.sync="model.recruitment_type"
                    v-model="model.recruitment_type"
                    :options="recruitment_type_options" 

                    :error="$v.model.recruitment_type.$error"
                    :errorMessage="$v.model.recruitment_type.errorMessage"
                  />
                </div>
                
              </div>

              <div class="row" v-if="model.recruitment_type != 'company'">

                <div class="col-6">
                  <TextField 
                    :placeholder="$t('user.form.first_name.placeholder')"
                    :label="$t('user.form.first_name.label')"
                    v-model="model.first_name"
                    :error="$v.model.first_name.$error"
                    :errorMessage="$v.model.first_name.errorMessage"
                  />
                </div>
                

                <div class="col-6">
                  <TextField 
                    :placeholder="$t('user.form.last_name.placeholder')"
                    :label="$t('user.form.last_name.label')"
                    v-model="model.last_name"
                    :error="$v.model.last_name.$error"
                    :errorMessage="$v.model.last_name.errorMessage"
                  />
                </div>

              </div>

              <div class="row" v-if="user.role.role == 'administration' || model.parent_id._id == user._id">
                <div class="form-group col-md-12">
                  <Multiselect
                    autoload
                    hasSelectAll
                    moduleName="industry"
                    endpoint="all"
                    v-model="model.industry_id"
                    :searchable="true"
                    :multiple="true"
                    :placeholder="$t('user.form.industry.placeholder')"
                    :clear-on-select="false"
                    :close-on-select="true"
                    :show-labels="false"
                    track-by="_id"
                    label="name"
                    :textLabel="$t('user.form.industry.label')"
                  />
                </div>

                <div class="form-group col-md-12">
                  <Multiselect
                    autoload
                    hasSelectAll
                    moduleName="function"
                    endpoint="all"
                    v-model="model.function_id"
                    :searchable="true"
                    :multiple="true"
                    :placeholder="$t('user.form.function.placeholder')"
                    :clear-on-select="false"
                    :close-on-select="true"
                    :show-labels="false"
                    track-by="_id"
                    label="name"
                    :textLabel="$t('user.form.function.label')"
                  />
                </div>

                <div class="form-group col-md-12" v-if="user.role.role != 'recruitment'">
                  <Multiselect
                    autoload
                    hasSelectAll
                    moduleName="brand"
                    endpoint="all"
                    v-model="model.brand_id"
                    :multiple="true"
                    :placeholder="$t('user.form.brand.placeholder')"
                    :clear-on-select="false"
                    :close-on-select="false"
                    :show-labels="false"
                    track-by="_id"
                    label="name"
                    :textLabel="$t('user.form.brand.label')"
                  />
                </div>
              </div>

              <div class="row" v-if="model.recruitment_type == 'company'">

                <div class="col-12">
                  <TextField 
                    :placeholder="$t('user.form.company.placeholder')"
                    :label="$t('user.form.company.label')"
                    v-model="model.company_name"
                    :error="$v.model.company_name.$error"
                    :errorMessage="$v.model.company_name.errorMessage"
                  />
                </div>

                <div class="col-6">
                  <TextField 
                    :placeholder="$t('user.form.city.placeholder')"
                    :label="$t('user.form.city.label')"
                    v-model="model.city"
                    :error="$v.model.city.$error"
                    :errorMessage="$v.model.city.errorMessage"
                  />
                </div>

                <div class="col-6">
                  <TextField 
                    :placeholder="$t('user.form.country.placeholder')"
                    :label="$t('user.form.country.label')"
                    v-model="model.country"
                    :error="$v.model.country.$error"
                    :errorMessage="$v.model.country.errorMessage"
                  />
                </div>

              </div>

              <div class="row" v-if="model.recruitment_type == 'company'">
                <div class="col-md-12">
                  <vue-editor height="300"
                    placeholder="Enter Company Description"
                    v-model="model.company_details">
                  </vue-editor>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-sm-4">
          <div class="card" v-if="user.role.role === 'administration'">
            <div class="card-body">
              <h4 class="header-title mt-0 mb-3">{{$t('user.form.commission_setup')}}</h4>
              <div class="form-group">
                <b-form-checkbox 
                  v-model="model.fixed" 
                  name="check-button" 
                  switch
                  @change="onBlur"
                  >
                  {{$t('user.form.use_fixed_rate')}}
                </b-form-checkbox>
              </div>
              <div class="row">
                <TextField 
                  :max="model.fixed ? 0 : 100"
                  :placeholder="model.fixed ? 'xx,xxx' : '%'"
                  :label="$t('user.form.commission_rate.label')"
                  type="number"
                  class="col-md-12"
                  v-model="model.rate"
                />
              </div>
            </div>
          </div>
          <div class="card" v-if="user.role.role === 'administration'">
            <div class="card-body">
              <div class="w-100">
                <File
                  ref="files"
                  file-size=5
                  accept=".pdf, .jpg"
                  v-model="model.files"
                  :placeholder="$t('user.form.upload_document')"
                  @delete="onDeleteFile"
                />
              </div>
            </div>
          </div>
          <div class="card" v-if="user.role.role === 'administration'">
            <div class="card-body">
              <div class="w-100">
                <DateTime
                  v-model="model.contract_start_date"
                  :placeholder="$t('user.form.contract_start_date.placeholder')"
                  :label="$t('user.form.contract_start_date.label')"
                ></DateTime>
              </div>
            </div>
          </div>
          <div class="card" v-if="user.role.role === 'administration'">
            <div class="card-body">
              <div class="w-100">
                <DateTime
                  v-model="model.contract_end_date"
                  :placeholder="$t('user.form.contract_end_date.placeholder')"
                  :label="$t('user.form.contract_end_date.label')"
                ></DateTime>
              </div>
            </div>
          </div>
        </div>
        <!-- end col -->
      </div>

    </form>
  <!-- </b-modal> -->
</template>

<script>
// import FixedHeader from 'vue-fixed-header'
/* import TextArea from '@components/form/textarea.vue' */
import TextField from '@components/form2/textfield.vue'
import DropDown from '@components/form2/dropdown.vue'
import DateTime from '@components/form2/dateTime.vue'
import FormMixin from '@mixins/form'
import Multiselect from '@components/form2/select/multiselect'
import File from '@components/form2/file2'

import { required, requiredIf } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import { VueEditor } from 'vue2-editor'

export default {
  mixins: [ FormMixin ],
  components:{
    TextField, 
    DropDown, 
    Multiselect, 
    VueEditor,
    DateTime,
    File,
    Select: () => import('@components/form2/select')
    // FixedHeader, 
  },
  data(){
    /* var type = this.$route.query.type, */
    // var aoptions = [{ value: null, text: 'Please select a Type' }]
  
    // //if(type == 'users'){
    //   aoptions.push({ value: 'administration', text: 'Administrator' })
    //   aoptions.push({ value: 'staff', text: 'Staff' })
    // //}

    return {
      model:{
        first_name: '',
        last_name: '',
        email: '',
        website:'',
        contact_no:'',
        access_type:null,
        recruitment_type:null,
        avatar_path:'',
        rate:0,
        fixed:false,
        removed: []
      },
      industry_options: [],
      function_options: [],
      brand_options:[],
      source_options:[],
      access_type_options: [],
      recruitment_type_options: [
        { value: null, text: 'Please select a Type' },
        { value: 'company', text: 'Company' },
        { value: 'individual', text: 'Individual' }
      ],
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth
    }
  },
  validations: {
    model:{
      first_name: { 
        required: requiredIf(function(item){
          return item.recruitment_type != 'company'
        })
      },
      last_name: { required: requiredIf(function(item){
          return item.recruitment_type != 'company'
        }) 
      },
      company_name: { 
        required: requiredIf(function(item){
          return item.recruitment_type == 'company'
        })
      },
      city: { 
        required: requiredIf(function(item){
          return item.recruitment_type == 'company'
        })
      },
      country: { 
        required: requiredIf(function(item){
          return item.recruitment_type == 'company'
        })
      },
      access_type: {
        required
      },
      contact_no: {
        required
      },
      recruitment_type: {
        required: requiredIf(function(item){
          return item.access_type == 'recruitment' && !item.recruitment_type
        })
      },
    }
  },
  async beforeMount(){
    await this.industryAll()
    .then(data => {
      data.data.forEach(el => {
        this.industry_options.push(el)
      })
    })
    .catch(err =>console.log(err.response.data))

    await this.$store.dispatch('user/candidate_source').then(data => {
      data.data.forEach(el => {
        this.source_options.push({ value: el.name, text: el.name })
      })
    })

    await this.functionAll().then(data => {
      data.data.forEach(el => {
        this.function_options.push(el) 
      })
    })

    await this.all_brand().then(data => {
      data.data.forEach(el => {
        this.brand_options.push(el) 
      })
    })
    
    // let type = this.parameters.type == 'users' ? 1 : this.parameters.type == 'company' ? 2 : this.parameters.type == 'individual' ? 3 : 3
    // await this.$store.dispatch('role/get', {type}).then(data => {
    //   data.data.forEach(el => {
    //     this.access_type_options.push({ value: el._id, text: el.name })
    //   })
    // })
    
    await this.fetchData()
  },
  mounted(){
    window.addEventListener('resize', this.handleResize)
  },
  updated(){
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    rowId() {
      let parameters = this.parameters || {}
      return parameters.rowId
    },
  },
  methods: {
    onView() {
      this.$emit('onView', this.rowId)
    },
    ...mapActions('user', ['update', 'findUser', 'uploadAvatar']),
    ...mapActions('function', {'functionAll':'all', 'all_brand':'all_brand'}),
    ...mapActions('industry', {'industryAll':'all'}),
    onAvatarChange(e) {
      let input = e.target

      if (input.files && input.files[0]) {
        this.toggleLoading()
        
        var formData = new FormData();

        formData.append("avatar", input.files[0]);
        formData.append("id", this.rowId);

        this.uploadAvatar(formData).then(res => {

          if(res.data.success == true){
            var reader = new FileReader();

            reader.onload = (a) => {
              this.$refs['imagePreview'].src = a.target.result
              this.toggleLoading()
            }

            reader.readAsDataURL(input.files[0]);
          }else{
            this.toggleLoading()
          }
          
        })
      }

    },
    onBlur(){
      if(parseInt(this.model.rate) > 100){
        this.model.rate = 100
      }
    },
    // onSave() {
    //   if (this.validateForm()) {
		// 		this.toggleLoading()
		// 		return;
		// 	}

    //   return this.update(this.model)
    //   .then(()=> {
    //     this.toggleLoading()
    //   })
    //   .catch((err) => {
    //     this.toggleLoading()

    //     Object.keys(err.response.data).forEach(key => {
    //       if(this.$v.model[key]) this.$v.model[key].errorMessage = err.response.data[key]
    //     })

    //     this.setError(err.response.data.msg)

    //   })
    // },
    async fetchData(){
      await this.findUser({ id:this.rowId })
      .then(res => {
        let { data } = res
        this.model = data.data
        this.model.rate = data.data.rate ? data.data.rate.$numberDecimal: 0
        this.model.parent_id = this.model.parent_id || {}
        this.model.access_type = this.model.role
        this.$refs.files.parseDocuments(this.model.attachments)
      })
      if(this.model.avatar_path && this.$refs['imageAvatar']){
        this.$refs['imageAvatar'].src = this.model.avatar_path
      }
    },
    handleResize () {
      let header = document.getElementById('sticky-header');
      this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

      if(header){
        header.style.width = this.fullWidth + 'px'
      }
    },
    onDeleteFile(files) {
      if(files) {
        let ids = files.map(ele => { return ele._id })
        this.model.removed = [...ids]
      }
    }         
  },
  watch:{
    'model.access_type':{
      handler: function() {
        if(this.model.access_type != 'recruitment'){
          this.model.recruitment_type = null
        }
      }
    },
    rowId: function () {
      this.fetchData()
    }
  }
}
</script>

